module.exports = __webpack_public_path__ + "static/blacksheep-ec0d258dd49b9f78ca2a048a97db69d5.svg";